import type { ReactNode } from 'react';

import { Icon, type IconName } from '@/components/orno/icon';

export interface EmptyStateProps {
  title: string;
  description?: ReactNode;
  icon?: IconName;
  /** A call to action, e.g. a "Create" button. */
  action?: ReactNode;
}

/** Shown when a list or page has nothing to display: orno's dashed empty state. */
export function EmptyState({ title, description, icon = 'folder', action }: EmptyStateProps) {
  return (
    <div className="empty-state">
      <Icon name={icon} size={24} />
      <div className="stack empty-state__text">
        <h2 className="h-sec">{title}</h2>
        {description ? <p className="p-mut">{description}</p> : null}
      </div>
      {action ? <div>{action}</div> : null}
    </div>
  );
}
